import {
  HttpContext,
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { ErrorService } from 'src/app/services/api-error.service';
import { INTERCEPTOR_CONFIG } from '../tokens';

export const urlPathname: (url: string) => string = (url: string) => new URL(url).pathname;

@Injectable({ providedIn: 'root' })
export class ErrorResponseInterceptor implements HttpInterceptor {
  private readonly endpoints: Map<string, HttpContext> = new Map();

  private config = inject(INTERCEPTOR_CONFIG);
  private errorService = inject(ErrorService);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.includes(this.config.apiUrl)) {
      return next.handle(request);
    }

    this.registerEndpoint(request.clone());

    return next.handle(request).pipe(
      tap({
        next: (event: HttpEvent<unknown>) => {
          if (event.type === HttpEventType.Response) {
            if (!event.url) {
              console.error('No URL provided');
              return;
            }

            this.endpoints.delete(urlPathname(event.url));
          }
        },

        error: (error: HttpErrorResponse) => {
          if (!error.url) {
            console.error('No URL provided');
            return;
          }

          this.errorService.handle(error, this.endpoints.get(urlPathname(error.url)) ?? new HttpContext());
          this.endpoints.delete(urlPathname(error.url));
        },
      }),
    );
  }

  private registerEndpoint(request: HttpRequest<unknown>): void {
    this.endpoints.set(urlPathname(request.url), request.context ?? new HttpContext());
  }
}
